var map = {
	"./多云.png": "0456",
	"./晴.png": "96a3",
	"./阴.png": "a19f",
	"./雨.png": "a542",
	"./雨夹雪.png": "677e",
	"./雪.png": "1520",
	"./雾.png": "e9d4",
	"./风.png": "bf76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5827";